export default "__VITE_ASSET__B5g_R4k7__"